import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router";
import _ from "lodash";

import {
  Container,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button
} from "reactstrap";

import { setPage, getAll } from "../../common/article/actions";
import { hashFromObj } from "../../common/lib/utils/hash";

import Pagination from "../components/Pagination/Pagination";

import moment from "moment";
moment.locale("pl");

class NewArticles extends React.Component {
  constructor() {
    super();
  }

  componentDidMount() {
    const { setPage } = this.props;

    setPage(1);
  }

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  redirectToSingle(uid) {
    this.redirect("/blog/" + uid);
  }

  render() {
    const { map, results, meta, setPage, apiHost, getAll } = this.props;
    const result = results && results.get(hashFromObj(meta && meta.toJS()));

    let limit = 0;
    const posts =
      result &&
      result.articles &&
      result.articles.map(r => {
        if (limit === 5) {
          return;
        }
        limit += 1;
        const date = moment(map.getIn([r, "addedAt"]));
        return (
          <div className="item" key={map.getIn([r, "uid"])}>
            <Link to={`/blog/${map.getIn([r, "slug"])}`}>
              {map.getIn([r, "title"])}
            </Link>
            <div className="meta">
              <span>{map.getIn([r, "author"])}</span>
              <span>{date && date.format("DD MMMM YYYY")}.r</span>
            </div>
            <div className="separator" />
          </div>
        );
      });

    return (
      <div className="recent">
        <Row className="flex-items-xs-right">
          <Col className="text-xs-left" xs="12" sm="11">
            <div className="title">Najnowsze posty</div>
            {posts ? posts.length === 0 ? (
              <div className="loading-spinner">Brak artykułów</div>
            ) : (
              posts
            ) : (
              <Col xs="12">
                <div className="loading-spinner">
                  <i className="loading-spinner fa fa-2x fa-circle-o-notch fa-spin" />
                </div>
              </Col>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

NewArticles.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default connect(
  state => ({
    apiHost: state.config.apiHost,
    map: state.article.map,
    results: state.article.results,
    meta: state.article.meta
  }),
  { setPage, getAll }
)(NewArticles);



/** WEBPACK FOOTER **
 ** ./src/browser/blog/NewArticles.js
 **/